import { ArrowRight } from 'lucide-react'
import { TELEGRAM_BOT_URL } from '@/lib/constants'

const BENEFITS = [
  'IA exclusiva para fútbol',
  'Solo picks Prematch',
  'Datos auditados en vivo',
  'Sin sesgo ni intuición',
]

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Background glow */}
      <div
        className="pointer-events-none absolute inset-x-0 -top-40 h-[560px] opacity-40"
        style={{
          background: 'radial-gradient(closest-side, rgb(var(--jl-brand) / 0.25), transparent 70%)',
        }}
      />

      <div className="relative max-w-5xl mx-auto px-5 pt-16 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* LEFT: Text + CTA */}
          <div>
            <p className="animate-fade-in-up text-xs font-semibold uppercase tracking-[0.2em] text-brand mb-4">
              Inteligencia. Datos. Valor.
            </p>
            <h1
              className="animate-fade-in-up font-display text-5xl sm:text-6xl font-extrabold leading-[0.95] tracking-tight"
              style={{ animationDelay: '60ms' }}
            >
              Picks de fútbol con{' '}
              <br />
              inteligencia artificial <span className="text-brand">real</span>
            </h1>
            <p
              className="animate-fade-in-up mt-6 text-base sm:text-lg text-text-dim max-w-xl leading-relaxed"
              style={{ animationDelay: '120ms' }}
            >
              Un Decision Engine que analiza cientos de señales por partido, publica el rendimiento
              real de sus recomendaciones y nunca inventa un dato. Todo dentro de Telegram.
            </p>

            {/* Benefits list */}
            <ul
              className="animate-fade-in-up mt-6 space-y-2"
              style={{ animationDelay: '160ms' }}
            >
              {BENEFITS.map((b) => (
                <li key={b} className="flex items-center gap-2 text-sm text-text-dim">
                  <span className="h-1.5 w-1.5 rounded-full bg-brand flex-shrink-0" />
                  {b}
                </li>
              ))}
            </ul>

            <div
              className="animate-fade-in-up mt-9 flex flex-col sm:flex-row items-start gap-3"
              style={{ animationDelay: '180ms' }}
            >
              <a
                href={TELEGRAM_BOT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-brand group"
              >
                Probar 5 días gratis
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </a>
              <a href="#resultados" className="btn-outline">
                Ver resultados reales
              </a>
            </div>
            <p className="animate-fade-in-up mt-4 text-xs text-text-dim" style={{ animationDelay: '220ms' }}>
              Sin tarjeta para el plan gratuito · Cancela cuando quieras
            </p>
          </div>

          {/* RIGHT: App screenshots composite */}
          <div
            className="hidden lg:flex items-center justify-center animate-slide-in-right"
            style={{ animationDelay: '200ms' }}
          >
            <div className="relative w-full max-w-xs mx-auto">
              {/* Main screenshot */}
              <div className="relative z-10 rounded-[28px] overflow-hidden border border-border shadow-brand-md animate-float">
                <img
                  src="/app-dashboard.jpg"
                  alt="Dashboard principal de John Anthony"
                  className="w-full object-cover"
                  loading="eager"
                />
              </div>
              {/* Secondary floating card - picks */}
              <div
                className="absolute -right-8 top-1/4 z-20 w-36 rounded-2xl overflow-hidden border border-brand/30 shadow-brand-sm"
                style={{ animation: 'float 4s ease-in-out infinite', animationDelay: '1.2s' }}
              >
                <img
                  src="/app-picks.jpg"
                  alt="Top Picks del día"
                  className="w-full object-cover object-top"
                  loading="eager"
                />
              </div>
              {/* Glow behind phone */}
              <div
                className="absolute inset-0 -z-10 rounded-[32px] blur-3xl opacity-30"
                style={{ background: 'rgb(var(--jl-brand) / 0.3)' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
